<template>
  <QuantitySelectDlg ref="quantity"/>
  <ConfirmDialog ref="confirm" />
  
  <NdsDlg
    v-if="selectedApplic"
    :isOpen.sync="isNdsDlgOpen"
    :application="selectedApplic"
    @update:isOpen="val => {
      isNdsDlgOpen = val;
      if (!val) selectedApplic = null;
    }"
  />

  <Card>
    <v-card-title class="cardTitle pa-0">
      {{ $t(title) }}
    </v-card-title>
    <div class="d-flex justify-space-between align-center" v-if="!decisionPositionsGridStore.hideActions">
      <v-card-subtitle
        v-if="applications.length > 0"
        class="cardSubTitle px-0"
      >
        {{ $t(subtitle) }}
      </v-card-subtitle>
      <v-spacer />
       <v-switch
        v-if="applications.length > 0"
        :label="$t('Показать цены без НДС')"
        hide-details
        inset
        class="mr-4"
        :model-value="isEnabled"
        @update:model-value="val => isEnabled = val"
      ></v-switch>
      <v-btn
        v-if="checkApplicationsDocuments()"
        variant="text"
        class="ml-auto h-auto"
        color="primary"
        @click="downloadDocuments(procedure.id)"
      >{{ $t('Скачать заявки') }}<v-icon size="21">custom:downloadFilesIcon</v-icon>
      </v-btn>
      <v-card-subtitle class="cardSubTitle px-0">
        {{ $t(`Всего предложений: {_1}`, {'_1': applications.length}) }}
      </v-card-subtitle>
    </div>
    <div class="d-flex justify-space-between align-center" v-else>
      <v-card-subtitle
        v-if="applications.length > 0"
        class="cardSubTitle px-0"
      >
        {{ $t(subtitle) }}
      </v-card-subtitle>
      <v-spacer/>
      <component
        v-if="decisionPositionsGridActionsComponent"
        :is="decisionPositionsGridActionsComponent"
        :applications="applications"
        :procedure="procedure"
        @update:selectedPositions="resetSelection"
      />
    </div>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <div
          v-if="applications.length > 0"
          class="positions-table-wrapper"
        >
          <table class="positions-table">
            <tbody>
            <tr
                v-for="(header, rowIndex) in headers"
                :key="header.key"
                :class="{
                  'header-row': rowIndex === 0,
                  'price-row': rowIndex === 1,
                }"
            >
              <td
                  class="sticky-col"
                  :class="{ 'header-col': rowIndex === 0 }"
              >
                {{ $t(header.title) }}
              </td>
              <td
                v-for="application in sortedApplications"
                :key="application.id"
                class="scroll-col"
                :class="{ 'header-col': rowIndex === 0 }"
              >
                <template v-if="header.key === companyKey">
                  <div
                      class="d-flex flex-column justify-space-between"
                  >
                    <div
                        class="d-flex justify-space-between align-center mt-4 company-block"
                       :class="{ 'has-app-files': application.hasFiles}"
                    >
                      <div class="text-decoration-none d-flex flex-row">
                        <div class="company-title">
                          {{ application[companyKey] }}
                          <v-tooltip
                              v-if="application[companyKey].length > 18"
                              activator="parent"
                              location="bottom"
                              width="750px"
                          >
                            {{ application[companyKey] }}
                          </v-tooltip>
                        </div>
                        <v-icon size="22" color="blue">mdi-check-decagram</v-icon>
                      </div>
                      <v-menu
                        v-if="application.hasFiles"
                        transition="slide-x-transition"
                        location="bottom right"
                      >
                        <template v-slot:activator="{ props }">
                          <v-btn
                            variant="text"
                            v-bind="props"
                            icon="mdi-dots-vertical"
                          />
                        </template>

                        <div class="secondaryActions">
                          <v-btn
                            variant="text"
                            color="primary"
                            @click="downloadDocument(application.id)"
                          >{{ $t('Скачать заявку') }}<v-icon size="21">custom:downloadFilesIcon</v-icon>
                          </v-btn>
                        </div>
                      </v-menu>
                    </div>
                    <div class="d-flex justify-end">
                      <v-btn
                        v-if="hasBidApplication(application)"
                        class="select-all-btn"
                        color="primary"
                        :variant="isSelectedAllCells(application.id) ? 'elevated' : 'outlined'"
                        @click="toggleAllSelection(application.id)"
                      >
                        {{ $t(isSelectedAllCells(application.id) ? 'Сбросить' : 'Выбрать все') }}
                      </v-btn>
                    </div>
                  </div>
                </template>
                <template v-else-if="header.key === 'offerPrice'">
                  <div
                      v-if="hasManyRounds"
                      class="d-flex align-center"
                  >
                    <div class="offerPriceArrow">
                      <v-icon
                          v-if="application.previous.offerPrice !== null && Number(application.offerPrice) < Number(application.previous.offerPrice)"
                          size="medium"
                      >
                        custom:offerPriceArrowIcon
                      </v-icon>
                      <v-icon
                          v-if="application.previous.offerPrice !== null && Number(application.offerPrice) > Number(application.previous.offerPrice)"
                          size="medium"
                      >
                        custom:offerPriceArrowRaiseIcon
                      </v-icon>
                    </div>
                    <div class="offerPrice d-flex flex-column">
                      <span
                          @click="application.nds.rate ? openDialog(application) : null"
                          :style="{ cursor: application.nds.rate ? 'pointer' : 'default' }"
                      >
                        {{ formatStartPrice(isEnabled ? calculateApplicationCost(application) : calculateApplicationCostNds(application)) }} $
                        <br>
                        <span
                          v-if="decisionPositionsGridStore.showNds"
                          class="nds"
                        >
                          {{getIsNdsText(isEnabled ? null : parseFloat(application?.nds?.rate), true)}}
                        </span>
                    </span>
                      <span
                          v-if="application.previous.offerPrice === null || application.offerPrice === application.previous.offerPrice"
                          class="offerPriceEmpty"
                      >{{ $t('не улучшалась') }}</span>
                      <span v-else class="offerPricePrev" @click="application.nds.rate ? openDialog(application.previous) : null">
                        {{ formatStartPrice(isEnabled ? calculateApplicationCost(application.previous) : calculateApplicationCostNds(application.previous)) }} $
                        <span
                          v-if="decisionPositionsGridStore.showNds"
                          class="nds"
                        >
                          {{getIsNdsText(isEnabled ? null : parseFloat(application?.nds?.rate), true)}}
                        </span>
                      </span>
                    </div>
                  </div>
                  <span
                      v-else
                      class="price"
                      :style="{ cursor: application.nds.rate ? 'pointer' : 'default' }"
                      @click="application.nds.rate ? openDialog(application) : null"
                  >
                    {{ formatStartPrice(isEnabled ? calculateApplicationCost(application) : calculateApplicationCostNds(application)) }} $
                    <span
                      v-if="decisionPositionsGridStore.showNds"
                      class="nds"
                    >
                      {{getIsNdsText(isEnabled ? null : parseFloat(application?.nds?.rate), true)}}
                    </span>
                  </span>
                </template>
                <template v-else>
                  {{ application[header.key] }}
                </template>
              </td>
            </tr>
            <tr class="specs-row">
              <td class="sticky-col sticky-row">
                <div class="d-flex flex-column ga-3">
                  <span>{{ $t(`Спецификации по позициям ({_1})`, {'_1': positions.length}) }}</span>
                  <v-btn
                    color="primary"
                    density="comfortable"
                    variant="outlined"
                    class="showUnitPriceBtn"
                    @click="showUnitPrice = !showUnitPrice"
                  >
                    <v-icon style="margin-right: 12px" color="primary">custom:eyeOutlineIcon</v-icon>
                    {{ $t(showUnitPriceCaption) }}
                  </v-btn>
                </div>
              </td>
              <td
                class="gray-background"
                :colspan="sortedApplications.length"
              ></td>
            </tr>
            <tr
              v-for="header in positionHeaders"
              :key="header.id"
              class="item-row"
            >
              <td class="sticky-col">
                <div class="d-flex flex-column justify-space-between">
                  <div class="position-title">
                    {{ $t(header.title) }}
                    <v-tooltip
                      v-if="header.title.length > 90"
                      activator="parent"
                      location="bottom"
                      width="750px"
                    >
                      {{ $t(header.title) }}
                    </v-tooltip>
                  </div>
                  <div
                    class="d-flex flex-row align-center"
                    :class="showDifference(header.id) ? 'justify-space-between' : 'justify-end'"
                  >
                    <div
                      v-if="showDifference(header.id)"
                      class="text-difference"
                    >
                      {{ $t(getQuantityDifferenceText(header.id)) }}
                    </div>
                    <div class="quantity-round">
                      {{ header.quantity }}
                    </div>
                  </div>
                </div>
              </td>
              <td
                v-for="application in sortedApplications"
                :key="application.id"
                class="scroll-col hover-cell"
                :class="{ 'selected-cell': isSelectedCell(application.id, header.id) }"
                style="vertical-align: top;"
              >
                <div
                  v-if="(position = getPositionByProcedureItemId(application.positions, header.id)) && position.price > 0"
                  class="d-flex flex-column justify-space-between"
                >
                  <div class="d-flex flex-column ga-2">
                    <span
                        class="price"
                        :style="{ cursor: application.nds.rate && !showUnitPrice ? 'pointer' : 'default' }"
                        @click="application.nds.rate && !showUnitPrice
                        ? openDialog(application, [getPositionByProcedureItemId(application.positions, header.id)])
                        : null"
                    >
                      {{
                        formatStartPrice((() =>{
                            const quantity = showUnitPrice ? 1 : getActualQuantity(application.id, header.id, position.quantity);
                            return isEnabled || showUnitPrice
                                ? calculatePositionCost(position, application.nds.rate, quantity)
                                : calculatePositionCostNds(position, application.nds.rate, quantity)
                        })())
                      }}
                      $ <span class="showUnitPriceText" v-if="showUnitPrice">{{ $t('цена за ед.') }}</span>
                    </span>
                    <div class="d-flex flex-row align-center ga-3">
                      <span class="quantity-view disabled">{{ showUnitPrice ? 1 : position.quantity }} {{ position.measure }}</span>
                      <div
                        v-if="partOfVolume && isSelectedCell(application.id, header.id)"
                        class="d-flex flex-row align-center ga-1"
                        :class="['quantity-round', 'quantity-round-green']"
                      >
                        <span>{{ `${getActualQuantity(application.id, header.id, position.quantity)} ${position.measure}` }}</span>
                        <v-btn
                          class="close-btn"
                          variant="text"
                          icon="mdi-close"
                          size="small"
                          @click="handleClick(application.id, header.id)"
                        ></v-btn>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="!partOfVolume || !isSelectedCell(application.id, header.id)"
                    class="d-flex justify-end"
                  >
                    <v-btn
                      class="select-all-btn"
                      :class="{ 'action-btn': !isSelectedCell(application.id, header.id) }"
                      color="primary"
                      variant="outlined"
                      @click="handleClick(application.id, header.id)"
                    >
                      {{ $t(isSelectedCell(application.id, header.id) ? 'Отменить' : 'Выбрать') }}
                    </v-btn>
                  </div>
                </div>
                <span v-else class="disabled">{{ $t('Не подано') }}</span>
              </td>
            </tr>
            <template v-if="Object.keys(selectedCells).length">
              <tr>
                <td
                  class="sticky-col sticky-row"
                  style="height: 65px;"
                >
                  <span>{{ $t('Итоговая цена') }}</span>
                </td>
                <td
                  class="gray-background"
                  :colspan="sortedApplications.length"
                ></td>
              </tr>
              <tr>
                <td
                  class="sticky-col sum-col"
                  style="vertical-align: top;"
                >
                  <span>{{ $t('Сумма заказа') }}</span>
                </td>
                <td
                  v-for="application in sortedApplications"
                  :key="application.id"
                  class="scroll-col sum-col"
                >
                  <div
                    v-if="getTotalPrice(application.id) > 0"
                    class="d-flex flex-column ga-3"
                  >
                    <span
                      class="price"
                      :style="{ cursor: application.nds.rate ? 'pointer' : 'default' }"
                      @click="application.nds.rate ? openDialog(application, application.positions, 0) : null"
                    >
                      <span class="price">{{ formatStartPrice(getTotalPrice(application.id)) }} $</span>
                      <span
                        v-if="decisionPositionsGridStore.showNds"
                        class="nds"
                      >
                        {{getIsNdsText(isEnabled ? null : parseFloat(application?.nds?.rate), true)}}
                      </span>
                    </span>
                    <div class="d-flex justify-start">
                      <v-chip class="winner-chip">{{ $t('Победитель') }}</v-chip>
                    </div>
                  </div>
                  <span v-else class="disabled">
                    0,00 $
                  </span>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <v-row
          v-else
          justify="center"
          class="py-6"
        >
          <span>{{ $t('Нет заявок') }}</span>
        </v-row>
      </v-col>
    </v-row>
    <v-card-title
      v-for="item in decisionPositionsGridStore.summarizeTotalPrices || []"
      :key="item.field"
      class="cardTitle pa-0"
    >
      <span v-if="getTotalPrice(null, item.field) > 0">
        {{ $t(item.name, { '_1': formatStartPrice(getTotalPrice(null, item.field)) }) }}
      </span>
    </v-card-title>
  </Card>
</template>

<script>
import { computed, onMounted } from "vue";
import Card from "@intec/vue-components/form/Card.vue";
import { getIsNdsText } from "@/lib/nds";
import { formatDateTimeNoTz, formatStartPrice } from '@/filters';
import QuantitySelectDlg from "@/components/application/dialogs/QuantitySelectDlg.vue";
import ConfirmDialog from "@intec/vue-components/form/ConfirmDialog.vue";
import NdsDlg from "@/components/application/dialogs/NdsDlg.vue";
import { useApplicationPositionCalculator } from '@/lib/applicationPosition';
import { useApplicationCalculator } from '@/lib/application';
import { useLibraryStore } from "@/stores/library";
import { useDecisionPositionsGridStore } from "@/stores/decisionPositionsGridStore";
import { useDecisionPositionsGridActionsComponentStore } from "@/stores/decisionPositionsGridActionsComponentStore";
import Decimal from "decimal.js-light";

export default {
  name: 'DecisionPositionsGrid',
  components: {
    QuantitySelectDlg,
    ConfirmDialog,
    NdsDlg,
    Card,
  },
  props: {
    applications: {
      type: Array,
      required: true
    },
    positions: {
      type: Array,
      required: true
    },
    procedure: {
      type: Object,
      required: true
    },
    hasManyRounds: {
      type: Boolean,
      required: true
    },
    selectedPositions: {
      type: Object,
      required: true
    },
  },
  setup(props) {
    const libraryStore = useLibraryStore();
    const decisionPositionsGridStore = useDecisionPositionsGridStore();
    const decisionPositionsGridActionsComponentStore = useDecisionPositionsGridActionsComponentStore();

    const decisionPositionsGridActionsComponent = computed(() => {
      return decisionPositionsGridActionsComponentStore.getComponentByType(props.procedure.type);
    });

    onMounted(() => {
      libraryStore.callActionByCode('initDecisionPositionsGridOptions', {
        procedureType: props.procedure.type,
      });
    });

    return {
      decisionPositionsGridStore,
      decisionPositionsGridActionsComponent,
    }
  },
  data() {
    return {
      formatDateTimeNoTz,
      formatStartPrice,
      title: 'Рассмотрение итогов закупки',
      subtitle: 'Определите победителя',
      companyKey: 'orgName',
      selectedApplic: null,
      showUnitPrice: false,
      isNdsDlgOpen: false,
      isEnabled: !this.procedure.isNds,
      confirmedPositions: new Set(),
    }
  },
  emits: ['update:selectedPositions'],
  computed: {
    selectedCells: {
      get() {
        return this.selectedPositions;
      },
      set(value) {
        this.$emit('update:selectedPositions', value);
      }
    },
    partOfVolume() {
      return this.procedure?.partOfVolume ?? false;
    },
    sortedApplications() {
      return [...this.applications].sort((a, b) => {
        const priceA = parseFloat(a.offerPrice) || 0;
        const priceB = parseFloat(b.offerPrice) || 0;
        return priceA - priceB;
      });
    },
    headers: function () {
      return [
        {title: 'Предложения поставщиков', key: this.companyKey},
        {title: 'Цена предложения', key: 'offerPrice'},
      ]
    },
    positionHeaders: function () {
      return (this.positions ?? []).map(position => ({
        title: position.name,
        quantity: `${position.quantity} ${position.measure}`,
        id: position.id
      }));
    },
    showUnitPriceCaption() {
      return this.showUnitPrice ? 'Показать общую стоимость'
          : (this.decisionPositionsGridStore.showNds ? 'Показать цены за единицу без НДС' : 'Показать цены за единицу');
    },

  },
  methods: {
    getIsNdsText,
    openDialog(applic = null, positions = null, undselectedQuantity = null) {
      let selectedPositions = null;

      if (positions) {
        selectedPositions = positions.map((position) => {
          const copyPosition = {...position};
          if (undselectedQuantity !== null) {
            copyPosition.quantity = undselectedQuantity;
          }
          if (this.selectedCells[position.procedureItemId]?.[applic.id]) {
            copyPosition.quantity = this.selectedCells[position.procedureItemId]?.[applic.id];
          }
          return copyPosition;
        });
      } else {
        selectedPositions = applic.positions;
      }
      this.selectedApplic = {
        offerPrice: applic.offerPrice,
        positions: selectedPositions,
        nds: {
          rate: applic.nds.rate
        }
      };
      this.isNdsDlgOpen = true;
    },
    resetSelection(newValue) {
      this.selectedCells = newValue;
      this.applications.forEach(app => app.isWinner = false);
    },
    async handleClick(applicationId, positionId) {
      const isSelected = this.isSelectedCell(applicationId, positionId);

      if (!isSelected && this.decisionPositionsGridStore.showConfirmModal && !this.confirmedPositions.has(positionId)) {
        let confirmValue = await this.$refs.confirm.open(
          'Выбор победителя',
          'Вы уверены, что хотите изменить победителя по позиции?',
        );
        if (!confirmValue) {
          return;
        }
        this.confirmedPositions.add(positionId);
      }

      if (this.partOfVolume && !isSelected) {
        return this.selectQuantity(applicationId, positionId);
      }

      return this.toggleSelection(applicationId, positionId);
    },
    getPositionByProcedureItemId(positions, id) {
      const pos = positions.find(pos => pos.procedureItemId === Number(id));
      return pos ? {...pos} : null;
    },
    async selectQuantity(applicationId, positionId) {
      const application = this.applications.find(app => app.id === applicationId);
      if (!application) return;

      const position = this.getPositionByProcedureItemId(
        application.positions || [],
        positionId
      );
      if (!position) return;

      const { confirmed, value } = await this.$refs.quantity.open(
        'Цена',
        position,
        {
          agreeText: 'Сохранить'
        }
      );

      if (confirmed) {
        this.toggleSelection(applicationId, positionId, value);
      }
    },
    hasSelectedPositions(applicationId, selection = null) {
      const currentSelection = selection || this.selectedCells;
      return Object.keys(currentSelection).some(posId =>
          currentSelection[posId]?.[applicationId]
      );
    },
    hasBidApplication(application) {
      const items = application.positions || [];

      return items.some(item => item.price);
    },
    toggleSelection(applicationId, positionId, quantity = null) {
      const position = this.positions.find(pos => pos.id === Number(positionId));
      const actualQuantity = quantity ?? position.quantity;

      const newSelection = { ...this.selectedCells };

      if (!newSelection[positionId]) {
        newSelection[positionId] = {};
      }

      const isSelected = !!newSelection[positionId]?.[applicationId];
      const app = this.applications.find(app => app.id === applicationId);

      if (isSelected) {
        delete newSelection[positionId][applicationId];
        if (Object.keys(newSelection[positionId]).length === 0) {
          delete newSelection[positionId];
        }

        if (app && !this.hasSelectedPositions(applicationId, newSelection)) {
          app.isWinner = false;
        }
      } else {
        if (this.partOfVolume) {
          newSelection[positionId][applicationId] = actualQuantity;
        } else {
          const oldAppId = Object.keys(newSelection[positionId])[0];
          const oldApp = this.applications.find(app => app.id === +oldAppId);

          newSelection[positionId] = { [applicationId]: actualQuantity };

          if (oldApp && oldApp.id !== applicationId && !this.hasSelectedPositions(oldApp.id, newSelection)) {
            oldApp.isWinner = false;
          }
        }

        if (app) app.isWinner = true;
      }

      this.selectedCells = newSelection;
    },
    isSelectedCell(applicationId, positionId) {
      return !!this.selectedCells[positionId]?.[applicationId];
    },
    toggleAllSelection(applicationId) {
      const application = this.applications.find(app => app.id === applicationId);
      if (!application) return;

      const allSelected = this.isSelectedAllCells(applicationId);
      const newSelection = { ...this.selectedCells };

      application.positions.forEach(pos => {
        if (pos.price <= 0) return;

        const positionId = pos.procedureItemId;

        if (allSelected) {
          if (newSelection[positionId]?.[applicationId]) {
            delete newSelection[positionId][applicationId];
            if (Object.keys(newSelection[positionId]).length === 0) {
              delete newSelection[positionId];
            }
          }
        } else {
          if (!newSelection[positionId]) newSelection[positionId] = {};

          if (!this.partOfVolume) {
            const prevAppId = Object.keys(newSelection[positionId] || {})[0];
            const prevApp = this.applications.find(app => app.id === +prevAppId);
            if (prevApp && prevApp.id !== applicationId) {
              prevApp.isWinner = false;
            }

            newSelection[positionId] = {
              [applicationId]: pos.quantity
            };
          } else {
            newSelection[positionId][applicationId] = pos.quantity;
          }
        }
      });

      if (allSelected && !this.hasSelectedPositions(applicationId, newSelection)) {
        application.isWinner = false;
      } else if (!allSelected && this.hasSelectedPositions(applicationId, newSelection)) {
        application.isWinner = true;
      }

      this.selectedCells = newSelection;
    },
    isSelectedAllCells(applicationId) {
      const application = this.applications.find(app => app.id === applicationId);
      if (!application) return false;

      return application.positions
        .filter(pos => pos.price > 0)
        .every(pos => this.selectedCells[pos.procedureItemId]?.[applicationId]);
    },
    getSum(price, quantity) {
      const numericPrice = parseFloat(price);
      const numericQty = parseFloat(quantity);

      if (isNaN(numericPrice) || isNaN(numericQty)) return 0;
      return numericPrice * numericQty;
    },
    getTotalPrice(applicationId = null, priceField = 'price') {
      let total = new Decimal(0);

      for (const [positionId, apps] of Object.entries(this.selectedCells)) {
        for (const [appId] of Object.entries(apps)) {
          if (applicationId && +appId !== +applicationId) continue;

          const application = this.applications.find(app => app.id === +appId);
          if (!application) continue;

          const position = this.getPositionByProcedureItemId(
            application.positions || [],
            positionId
          );
          if (!position || (position[priceField] ?? 0) <= 0) continue;

          const quantity = this.getActualQuantity(+appId, positionId, position.quantity);
          const calculator = this.getPositionCostCalucator(position, application.nds.rate, priceField);
          total = total.plus(new Decimal(this.isEnabled ? calculator.getCostForQuantity(quantity) : calculator.getCostNdsForQuantity(quantity)));
        }
      }

      return total.toString();
    },
    getActualQuantity(applicationId, positionId, defaultQuantity) {
      const cell = this.selectedCells[positionId];
      if (!cell || !cell[applicationId]) return defaultQuantity;
      return cell[applicationId];
    },
    showDifference(positionId) {
      return this.partOfVolume &&  this.getQuantityDifferenceText(positionId);
    },
    getQuantityDifferenceText(positionId) {
      const selected = this.selectedCells[positionId];
      if (!selected || Object.keys(selected).length === 0) return '';

      const totalSelectedQuantity = Object.values(selected).reduce((sum, quantity) => sum + quantity, 0);
      if (totalSelectedQuantity === 0) return '';

      const position = this.positions.find(pos => pos.id === positionId);
      if (!position) return '';

      const difference = totalSelectedQuantity - position.quantity;
      const formattedDifference = Math.abs(difference).toFixed(2);

      if (difference < 0) {
        return this.$t(`Общий объем меньше на {_1} ед.`, {'_1': formattedDifference});
      } else if (difference > 0) {
        return this.$t(`Общий объем превышен на {_1} ед.`, {'_1': formattedDifference});
      }

      return '';
    },
    checkApplicationsDocuments () {
      return this.applications.some((applic) => applic.hasFiles);
    },
    async downloadDocuments(procedureId) {
      window.location.href = '/procedures/downloadAllDocumentsApplication/' + procedureId;
    },
    async downloadDocument(applicationId) {
      window.location.href = '/procedures/downloadAllDocumentsApplication/' + this.procedure.id +
        `?applicationId=${applicationId}`;
    },
    getPositionCostCalucator(position, ndsRate, priceField = 'price') {
      return useApplicationPositionCalculator(position, ndsRate, priceField);
    },
    calculatePositionCost(position, ndsRate, quantity) {
      return this.getPositionCostCalucator(position, ndsRate).getCostForQuantity(quantity);
    },
    calculatePositionCostNds(position, ndsRate, quantity) {
      return this.getPositionCostCalucator(position, ndsRate).getCostNdsForQuantity(quantity);
    },
    getApplicationCostCalucator(application) {
      return useApplicationCalculator(application, application.positions, application.nds.rate);
    },
    calculateApplicationCost(application) {
      return this.getApplicationCostCalucator(application).getTotalCost();
    },
    calculateApplicationCostNds(application) {
      return this.getApplicationCostCalucator(application).getTotalCostNds();
    },
  }
}
</script>

<style lang="scss" scoped>
.positions-table-wrapper {
  border: 1px solid rgb(var(--positions-table-border-color));
  border-radius: 8px;
  overflow-x: auto;
  position: relative;

  .positions-table {
    border-collapse: separate;
    border-spacing: 0;
    min-width: max-content;
    width: 100%;
    font-size: 14px;
    font-style: normal;
    line-height: 20px;
    border: none;

    /* Предложения поставщиков */
    .header-row {
      > td {
        height: 120px
      }
      .scroll-col > div {
        height: 100%;
        background-color: rgb(var(--positions-table-title-color));
      }

      .company-block {
        height: 45px;

        .company-title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    /* Цена предложения */
    .price-row {
      > td {
        height: 46px
      }
      .price {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        white-space: normal;
        word-break: break-word;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    /* Позиции */
    .item-row {
      > td {
        height: 100px;
      }

      > td:first-child {
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: top;
      }

      > td:first-child > div {
        max-width: 500px;
      }

      > td > div {
        height: 100%;
      }
    }

    /* Спецификации по позициям */
    .specs-row {
      td:first-child {
        max-width: 500px;
        height: 130px;
        background-color: rgb(var(--positions-table-title-color));
      }
    }
  }

  .select-all-btn {
    height: 25px !important;
    min-width: 105px;
    font-size: 14px;
    line-height: normal;
    letter-spacing: normal;
    border: 1px solid rgb(var(--positions-table-border-color));
    background-color: #fff;
  }

  .sticky-col {
    font-weight: 600;
    position: sticky;
    left: 0;
    z-index: 2;
    background: #fff;
    width: 300px;
  }

  .sticky-row {
    border-right: none;
  }

  .scroll-col {
    max-width: 220px;
  }

  .gray-background {
    background-color: rgb(var(--positions-table-title-color));
  }

  .header-col {
    background-color: rgb(var(--positions-table-title-color));
  }

  .quantity-round {
    border-radius: 8px;
    background-color: rgb(var(--quantity-round));
    padding: 5px 20px;
    display: flex;
    justify-content: center;
    font-size: 12px;
  }

  .quantity-round-green {
    background-color: rgb(var(--quantity-round-green));

    .close-btn {
      width: 16px;
      height: 16px;
      font-size: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .quantity-view {
    font-size: 12px;
  }

  .disabled {
    color: rgb(var(--positions-table-disabled-color));
  }

  .position-title {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: normal;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .sum-col {
    font-weight: 500;
    vertical-align: top;
    height: 106px;
  }

  .price {
    font-size: 18px;
  }

  .selected-cell {
    background-color: rgba(var(--positions-table-selected-color), 0.3);
  }

  .hover-cell {
    transition: background-color 0.2s ease;
    position: relative;
  }

  .hover-cell:hover {
    background-color: rgba(var(--positions-table-selected-color), 0.3);
    z-index: 1;
  }

  .action-btn {
    opacity: 0;
    transition: opacity 0.2s ease;
    pointer-events: none;
  }

  .hover-cell:hover .action-btn {
    opacity: 1;
    pointer-events: auto;
  }

  .winner-chip {
    --circle-color: rgb(var(--circle-success-color));
    color: var(--circle-color);
    font-size: 14px;
  }

  .secondaryActions {
    display: inline-flex;
    padding: 5px 0;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.4);
  }

  .showUnitPriceBtn {
    max-width: fit-content;
    padding: 9px 15px;
    background-color: #fff;
    border: 1px solid rgb(var(--positions-table-border-color));
  }

  .showUnitPriceText {
    font-size: 12px;
    color: var(--positions-unit-price-text);
  }

  .text-difference {
    font-size: 12px;
  }

  .offerPriceArrow {
    width: 22px;
  }

  .offerPricePrev {
    text-decoration-line: line-through;
    font-size: 14px;
    color: rgb(var(--unactive-text-color));
  }

  .offerPriceEmpty {
    font-size: 14px;
    color: rgb(var(--unactive-text-color));
  }
}

.positions-table-wrapper th,
.positions-table-wrapper td {
  padding: 10px;
  border-bottom: 1px solid rgb(var(--positions-table-border-color));
  border-right: 1px solid rgb(var(--positions-table-border-color));
  white-space: nowrap;
}

.positions-table-wrapper th:last-child,
.positions-table-wrapper td:last-child {
  border-right: none;
}

.positions-table-wrapper tr:last-child th,
.positions-table-wrapper tr:last-child td {
  border-bottom: none;
}

:deep(.positions-table-wrapper tbody) {
  font-size: 16px;
  font-weight: 500;
}

:deep(.v-chip__content::before) {
  display: block;
  content: '';
  background-color: var(--circle-color);
  width: 8px;
  height: 8px;
  border-radius: 100%;
  margin-right: 6px;
}

.secondaryActions {
  display: inline-flex;
  padding: 5px 0;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.4);
}

.showUnitPriceBtn {
  width: fit-content;
  padding: 9px 15px;
  background-color: #fff;
  border: 1px solid rgb(var(--positions-table-border-color));
}

.showUnitPriceText {
  font-size: 12px;
  color: var(--positions-unit-price-text);
}

.nds {
  font-weight: 400;
}

/* v-switch */
:deep(.v-input--density-default) {
  --v-input-control-height: 28px;
}

:deep(.v-selection-control--density-default) {
  --v-selection-control-size: 28px;
}

:deep(.v-switch) {
  margin-left: auto;
}

:deep(.v-switch .v-label) {
  color: rgb(var(--v-theme-primary));
  opacity: 1;
  font-family: var(--primary-font-family-name);
  font-weight: 500;
  font-size: 16px;
}

:deep(.v-switch .v-selection-control) {
  max-height: var(--v-input-control-height);
  flex-direction: row-reverse;
  gap: 10px;
}

:deep(.v-switch .v-switch__track) {
  height: 28px;
  opacity: 1;
}

:deep(.v-switch .v-selection-control.v-selection-control--dirty .v-switch__track) {
  background-color: var(--blue-blue-hover);
}

:deep(.v-switch .v-selection-control:not(.v-selection-control--dirty) .v-switch__track) {
  background-color: #c7c7c7;
}

:deep(.v-switch .v-switch__thumb) {
  transform: none;
}
</style>
